import { defineComponent as oe, ref as m, computed as i, useSlots as P, watch as ne, nextTick as v, onMounted as le, onUnmounted as ie, openBlock as r, createBlock as h, unref as b, normalizeStyle as q, withCtx as o, createVNode as B, normalizeClass as O, createElementVNode as N, createElementBlock as se, renderSlot as s, createCommentVNode as k } from "vue";
import { isTopModal as ce, getModalStackIndex as re, pushModal as de, popModal as G, generateModalId as ue } from "./index298.js";
import Y from "./index299.js";
import Z from "./index300.js";
import K from "./index301.js";
import { useDraggable as fe } from "./index302.js";
import { Dialog as me, DialogOverlay as he, DialogPanel as U } from "./index303.js";
const we = { class: "modal-container-wrapper" }, xe = /* @__PURE__ */ oe({
  __name: "BaseModal",
  props: {
    isOpen: { type: Boolean, default: !1 },
    title: {},
    description: {},
    size: { default: "md" },
    variant: { default: "default" },
    alertVariant: {},
    closeOnOverlayClick: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackButton: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !0 },
    showDefaultFooter: { type: Boolean, default: !0 },
    actions: { default: () => [] },
    cancelText: { default: "취소" },
    confirmText: { default: "확인" },
    showCancelButton: { type: Boolean, default: !0 },
    showConfirmButton: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !0 },
    contentPadding: { default: "default" },
    draggable: { type: Boolean, default: !1 }
  },
  emits: ["close", "back", "cancel", "confirm", "action", "update:isOpen"],
  setup(e, { emit: X }) {
    const j = {
      sm: 400,
      md: 500,
      lg: 600,
      xl: 800
    }, n = e, d = X, w = m(), C = m(null), $ = m(null), {
      style: J,
      x: M,
      y: S
    } = fe(C, {
      initialValue: { x: 0, y: 0 },
      preventDefault: !0,
      disabled: i(() => !n.draggable),
      handle: $
    }), A = m(), x = m(), g = ue(), F = i(() => ce(g)), Q = i(() => re(g)), p = i(() => ({
      "--modal-stack-index": Q.value
    })), E = i(() => `modal-size-${n.size}`), T = i(() => `modal-variant-${n.variant}`), W = i(() => !!P().header), H = i(() => !!P().footer), D = m(!1), _ = () => {
      if (!w.value) return;
      const t = w.value.$el || w.value, c = t.querySelector("footer") ? 'footer button, footer a[role="button"]' : '.modal-content button, .modal-content a[role="button"]', l = t.querySelectorAll(c);
      if (l.length === 0) return;
      let a = t.querySelector('[data-modal-primary-action="true"]');
      return a || (a = Array.from(l).find((f) => {
        const y = f.classList;
        return y.contains("btn-variant-contained") && y.contains("btn-color-primary");
      }), a) || (a = Array.from(l).find((f) => f.classList.contains("btn-variant-contained")), a) ? a : l[0];
    }, ee = async () => {
      await v(), await v();
      const t = _();
      t && (x.value = t);
    };
    ne(
      () => n.isOpen,
      async (t) => {
        if (t) {
          if (de(g), n.draggable) {
            await v(), await v();
            const c = () => {
              const l = C.value;
              if (!l) return;
              const a = l.offsetWidth, f = l.offsetHeight;
              if (a > 0 && f > 0)
                M.value = Math.max(0, (window.innerWidth - a) / 2), S.value = Math.max(0, (window.innerHeight - f) / 2);
              else {
                const y = j[n.size] ?? 500, ae = 480;
                M.value = Math.max(0, (window.innerWidth - y) / 2), S.value = Math.max(0, (window.innerHeight - ae) / 2);
              }
            };
            c(), requestAnimationFrame(() => c());
          }
          await ee();
        } else
          G(g), x.value = void 0;
      },
      { flush: "post", immediate: !0 }
    );
    const u = () => {
      d("close"), d("update:isOpen", !1);
    }, te = () => {
      D.value ? (n.closeOnEscape && u(), D.value = !1) : n.closeOnOverlayClick && u();
    }, I = (t) => {
      n.isOpen && t.key === "Escape" && (D.value = !0);
    };
    le(() => {
      document.addEventListener("keydown", I, !0);
    }), ie(() => {
      document.removeEventListener("keydown", I, !0), G(g);
    });
    const L = () => {
      d("back");
    }, R = () => {
      d("cancel"), u();
    }, V = () => {
      d("confirm"), u();
    }, z = (t, c) => {
      d("action", t, c);
    };
    return (t, c) => (r(), h(b(me), {
      open: e.isOpen,
      "initial-focus": x.value,
      onClose: te,
      class: "modal-dialog",
      style: q(p.value)
    }, {
      default: o(() => [
        B(b(he), {
          class: O(["modal-overlay", { "modal-overlay--no-dim": e.draggable }])
        }, null, 8, ["class"]),
        N("div", we, [
          e.draggable ? (r(), se("div", {
            key: 0,
            ref_key: "draggableWrapperRef",
            ref: C,
            class: "modal-container-draggable-wrapper",
            style: q(b(J))
          }, [
            B(b(U), {
              ref_key: "modalContainer",
              ref: w,
              class: O([
                "modal-container",
                E.value,
                T.value,
                "modal-container--draggable"
              ]),
              inert: !F.value,
              tabindex: "-1"
            }, {
              default: o(() => [
                N("div", {
                  ref_key: "draggableHandleRef",
                  ref: $,
                  class: "modal-draggable-handle"
                }, [
                  W.value || e.title || e.showCloseButton || e.showBackButton ? (r(), h(Z, {
                    key: 0,
                    title: e.title,
                    "show-back-button": e.showBackButton,
                    "show-close-button": e.showCloseButton,
                    onBack: L,
                    onClose: u
                  }, {
                    title: o(() => [
                      s(t.$slots, "title")
                    ]),
                    actions: o(() => [
                      s(t.$slots, "actions")
                    ]),
                    _: 3
                  }, 8, ["title", "show-back-button", "show-close-button"])) : k("", !0)
                ], 512),
                B(Y, {
                  description: e.description,
                  "alert-variant": e.alertVariant,
                  "show-alert-icon": e.variant === "alert",
                  "content-padding": e.contentPadding
                }, {
                  default: o(() => [
                    s(t.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["description", "alert-variant", "show-alert-icon", "content-padding"]),
                H.value || e.actions.length > 0 || e.showDefaultFooter ? (r(), h(K, {
                  key: 0,
                  ref_key: "modalFooterRef",
                  ref: A,
                  actions: e.actions,
                  "show-default-footer": e.showDefaultFooter,
                  "cancel-text": e.cancelText,
                  "confirm-text": e.confirmText,
                  "show-cancel-button": e.showCancelButton,
                  "show-confirm-button": e.showConfirmButton,
                  "full-width": e.fullWidth,
                  onCancel: R,
                  onConfirm: V,
                  onAction: z
                }, {
                  default: o(() => [
                    s(t.$slots, "footer")
                  ]),
                  _: 3
                }, 8, ["actions", "show-default-footer", "cancel-text", "confirm-text", "show-cancel-button", "show-confirm-button", "full-width"])) : k("", !0)
              ]),
              _: 3
            }, 8, ["class", "inert"])
          ], 4)) : (r(), h(b(U), {
            key: 1,
            ref_key: "modalContainer",
            ref: w,
            class: O(["modal-container", E.value, T.value]),
            inert: !F.value,
            tabindex: "-1"
          }, {
            default: o(() => [
              W.value || e.title || e.showCloseButton || e.showBackButton ? (r(), h(Z, {
                key: 0,
                title: e.title,
                "show-back-button": e.showBackButton,
                "show-close-button": e.showCloseButton,
                onBack: L,
                onClose: u
              }, {
                title: o(() => [
                  s(t.$slots, "title")
                ]),
                actions: o(() => [
                  s(t.$slots, "actions")
                ]),
                _: 3
              }, 8, ["title", "show-back-button", "show-close-button"])) : k("", !0),
              B(Y, {
                description: e.description,
                "alert-variant": e.alertVariant,
                "show-alert-icon": e.variant === "alert",
                "content-padding": e.contentPadding
              }, {
                default: o(() => [
                  s(t.$slots, "default")
                ]),
                _: 3
              }, 8, ["description", "alert-variant", "show-alert-icon", "content-padding"]),
              H.value || e.actions.length > 0 || e.showDefaultFooter ? (r(), h(K, {
                key: 1,
                ref_key: "modalFooterRef",
                ref: A,
                actions: e.actions,
                "show-default-footer": e.showDefaultFooter,
                "cancel-text": e.cancelText,
                "confirm-text": e.confirmText,
                "show-cancel-button": e.showCancelButton,
                "show-confirm-button": e.showConfirmButton,
                "full-width": e.fullWidth,
                onCancel: R,
                onConfirm: V,
                onAction: z
              }, {
                default: o(() => [
                  s(t.$slots, "footer")
                ]),
                _: 3
              }, 8, ["actions", "show-default-footer", "cancel-text", "confirm-text", "show-cancel-button", "show-confirm-button", "full-width"])) : k("", !0)
            ]),
            _: 3
          }, 8, ["class", "inert"]))
        ])
      ]),
      _: 3
    }, 8, ["open", "initial-focus", "style"]));
  }
});
export {
  xe as default
};
